import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import TablesTemplate from './table_template';
import { ADD_ROW, ConvertStatus, DELETE_ROW, JSON_KEY_CODE, 
   JSON_KEY_STATUS, TABLE_HEADER_STATUS, TABLE_HEADER_TYPE, UPDATE_ROW, 
   // JSON_KEY_ID, TABLE_HEADER_ID,  
   JSON_KEY_USER, TABLE_HEADER_USER, TABLE_HEADER_FIRM, JSON_KEY_FIRM, JSON_KEY_TRADING_ACCOUNT_TYPE,
   GENERAL_ID, GENERAL_NAME, HOUSE_ID, HOUSE_NAME, INSTITUTIONAL_NAME, INSTITUTIONAL_ID, OMNIBUS_ID,
   OMNIBUS_NAME, UNKNOWN, FOREIGN_ID, FOREIGN_NAME, DROPDOWN_LIST_NONE, ADD_USER, ADD_PARTICIPANT,
   TABLE_HEADER_DESCRIPTION, JSON_KEY_DESCRIPTION, AddItemToDropdown, TABLE_HEADER_CODE,
   OTHER_ID,
   OTHER_NAME,
   instrumentCodeColor,
   rowOpacityForStatus,
   statusTextColor}  
from '../../common/common';
import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import TradingAccountsAdminForm from '../forms/trading_accounts_admin_form';
import { addAccounts } from '../../redux/dropDownSlice';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';

function ConvertTradingAccountType(type) {
   switch (type) {
      case (FOREIGN_ID):
         return FOREIGN_NAME;
      case (GENERAL_ID):
         return GENERAL_NAME;
         case (HOUSE_ID):
         return HOUSE_NAME;
      case (INSTITUTIONAL_ID):
         return INSTITUTIONAL_NAME;
      case (OMNIBUS_ID):
         return OMNIBUS_NAME;
      case (OTHER_ID):
         return OTHER_NAME;
      default:
         return UNKNOWN;
   }
};

const  TradingAccounts2 = () => {
   const dispatch = useDispatch();
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const [dropDownTradingAccountData, setDropDownTradingAccountData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const [dropDownParticipantData, setDropDownParticipantData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const [dropDownUserData, setDropDownUserData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);

   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[ TradingAccountsTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[ TradingAccountsTable] Row Double Clicked:`, rowData);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log(`[TradingAccountsTable] Event Details:`, details.data);
      const raw = details.data;
      const formatted = {
         ...raw,
         id: raw.code,
         ta_type: ConvertTradingAccountType(raw.ta_type),
         status: ConvertStatus(raw.status),
      };
   
      switch (details.type) {
         case ADD_ROW: {
            setLocalTableData(prev => {
               const isDuplicate = prev.some(row => row.id === formatted.id);
               if (isDuplicate) {
                  console.log(`[TradingAccountsTable] Duplicate row ignored:`, formatted.id);
                  return prev;
               }
   
               return [...prev, formatted];
            });

            AddItemToDropdown(setDropDownTradingAccountData, { id: details.data.code, name: details.data.code });
            dispatch(addAccounts({ id: formatted.code, name: formatted.code })); // Add for drop down lists
            

            break;
         }
   
         case UPDATE_ROW:
            setLocalTableData(prev => prev.map(row => row.id === formatted.id ? formatted : row));
            break;
   
         case DELETE_ROW:
            setLocalTableData(prev => prev.filter(row => row.id !== raw.code));
            break;
      
         case ADD_PARTICIPANT:
            AddItemToDropdown(setDropDownParticipantData, { id: details.data.code, name: details.data.code });
            break;
      
         case ADD_USER:
            AddItemToDropdown(setDropDownUserData, { id: details.data.code, name: details.data.code });
            break;
      
         default:
            break;
      }
   }, [setDropDownTradingAccountData, dispatch]);

   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_CODE] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);
   
   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID },  // don't show it but it is still there
      { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
      { Header: TABLE_HEADER_FIRM, accessor: JSON_KEY_FIRM },
      { Header: TABLE_HEADER_USER, accessor: JSON_KEY_USER },
      { Header: TABLE_HEADER_TYPE, accessor: JSON_KEY_TRADING_ACCOUNT_TYPE },
      { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="TradingAccountsTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            enableSearch={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}
         />
         <Modal show={showForm} onHide={handleCloseForm}>
            <TradingAccountsAdminForm rowData={selectedRow} onClose={handleCloseForm} tradingAccountOptions={dropDownTradingAccountData} userOptions={dropDownUserData} firmOptions={dropDownParticipantData} />
         </Modal>
      </>
   );
};

export default  TradingAccounts2;
